import { useEffect, useState } from "react";

import axios from "axios";
import Swal from "sweetalert2";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import About from "../components/home/About";
import Banner from "../components/home/Banner";
import Blog from "../components/home/Blog";
import Event from "../components/home/Event";
import Service from "../components/home/Service";
import Review from "../components/home/Review";
import Contact from "../components/home/Contact";
import Partners from "../components/home/Partners";
import usePreventRefresh from "../components/common/usePreventRefresh";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.result === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // usePreventRefresh();

  return (
    <div className=" relative w-full h-full">
      <h1 className="sr-only">
        집치울때 - 서울·경기·인천 유품정리, 빈집정리, 특수청소, 쓰레기집청소, 고독사청소 전문업체
      </h1>
      <Banner />
      <About />
      <Service />
      <Event />
      <Blog data={data} />
      <Review />
      <Contact />
      <Partners />
    </div>
  );
};

export default Home;
